import { cdnGetRequest } from "../../utils/webrequests";
import { ConferenceInfo } from "../../data/conferenceInfo";

export async function getConferenceInformation(): Promise<ConferenceInfo>{
        const data:ConferenceInfo = await cdnGetRequest("cdn-data/conferenceinfo.json");
        return data;
};